let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kmeN2")).then(() => parcelRequire('2GYK9'));